var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAirplaneTakeOff = function SvgAirplaneTakeOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.983 16.593a.8.8 0 0 0-.566.98l1.346 5.023 1.553 5.795L19.08 25.93l.964 3.597c.406 1.518 2.323 1.996 3.394.847l6.205-6.655 9.59-2.007c1.504-.315 2.106-2.136 1.087-3.285l-2.007-2.264a4 4 0 0 0-4.028-1.21L9.627 21.561l-.725-2.705a3.2 3.2 0 0 0-3.919-2.263ZM6 36a2 2 0 1 0 0 4h36a2 2 0 1 0 0-4H6Z",
    clipRule: "evenodd"
  })));
};
export default SvgAirplaneTakeOff;